/**
 * ShellContent -- scrollable content area of the Chat shell for non-chat
 * routes (/settings*) and the skeleton shown while a lazy page loads.
 * The shell stays mounted and interactive during the load (design.md K.6).
 */

import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { Skeleton } from '@/components/ui/Skeleton';
import { useChatShell } from './useChatShell';

export function ShellContentFallback() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-8 space-y-6" aria-busy="true">
      <Skeleton className="h-10 w-64" />
      <Skeleton className="h-9 w-full" />
      <Skeleton className="h-48 rounded-xl" />
    </div>
  );
}

export function ShellPageContainer() {
  // Forward the shell context: this layout route sits between the shell and the page.
  const shell = useChatShell();
  return (
    <div className="flex-1 min-h-0 overflow-y-auto">
      <div className="animate-fade-in">
        <Suspense fallback={<ShellContentFallback />}>
          <Outlet context={shell} />
        </Suspense>
      </div>
    </div>
  );
}
